// =================================================================
// AMG Engine — Result type + EngineError discriminated union (PSD §4.1)
// Pure module: no framework imports.
// =================================================================
export const ok = (value) => ({ ok: true, value });
export const err = (code, message, field) => ({
    ok: false,
    error: { code, message, field },
});
/** True if the result is Ok. */
export function isOk(r) {
    return r.ok;
}
/** True if the result is Err. */
export function isErr(r) {
    return !r.ok;
}
/** Engine version (single source — injected from package.json via Vite define). */
export const ENGINE_VERSION = VITE_APP_VERSION;
//# sourceMappingURL=types.js.map